import template from './about.html'

const pageAbout = () => {
  return {
    title: 'О ПРИЛОЖЕНИИ',
    version: '-',
    async init() {
      try {
        const info = await this.callIOS('info')
        this.version = this.app.version + ' (' + info.bundle + ')'
      } catch(e) {
        console.log(e)
      }
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    }
  }
}

export { pageAbout }
